import { useTranslation } from "react-i18next";
import { Check, Eye, X } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { localPick } from "../../lib/localName";

const TONE = {
  pending: "text-warning", approved: "text-destructive",
  rejected: "text-muted-foreground", cancelled: "text-muted-foreground",
};

// صف عقوبة واحد: الأزرار محكومة بالدور وبحالة العقوبة.
export const PenaltyRow = ({ row, index, isAdmin, onApprove, onReject, onCancel, onView }) => {
  const { t } = useTranslation();
  return (
    <tr className="border-b border-border/40" data-testid={`penalty-row-${row.penalty_id}`}>
      <td className="p-2 num text-xs text-muted-foreground">{index + 1}</td>
      <td className="p-2 num font-mono text-xs font-black whitespace-nowrap text-blue-800 dark:text-blue-300">{row.serial_number}</td>
      <td className="p-2 text-xs font-bold">{localPick(row, "employee_name")}</td>
      <td className="p-2 text-xs">{t(`penalty.types.${row.penalty_type}`)}</td>
      <td className="p-2 text-xs">{t(`penalty.reasons.${row.reason_category}`)}</td>
      <td className="p-2 num font-mono text-xs font-black whitespace-nowrap">
        {Number(row.deduction_amount) > 0
          ? <span className="text-destructive">{row.deduction_amount} {row.currency}</span>
          : <span className="text-muted-foreground">—</span>}
      </td>
      <td className="p-2 num font-mono text-xs font-black whitespace-nowrap">
        {row.final_settlement && Number(row.final_settlement) !== 0
          ? <span className="text-success">{row.final_settlement} {row.currency}</span>
          : <span className="text-muted-foreground">—</span>}
      </td>
      <td className={`p-2 text-xs font-bold ${TONE[row.status] || ""}`}>{t(`penalty.status.${row.status}`)}</td>
      <td className="p-2 num font-mono text-xs whitespace-nowrap" dir="ltr">{row.effective_date}</td>
      <td className="p-2">
        <div className="flex flex-wrap items-center gap-1">
          {isAdmin && row.status === "pending" ? (
            <>
              <NeuButton className="px-2 py-1 text-success" data-testid={`penalty-approve-btn-${row.penalty_id}`}
                         onClick={() => onApprove(row)} title={t("penalty.actions.approve")}>
                <Check className="h-3.5 w-3.5" />
              </NeuButton>
              <NeuButton className="px-2 py-1 text-destructive" data-testid={`penalty-reject-btn-${row.penalty_id}`}
                         onClick={() => onReject(row)} title={t("penalty.actions.reject")}>
                <X className="h-3.5 w-3.5" />
              </NeuButton>
            </>
          ) : null}
          <NeuButton className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-bold text-primary" data-testid={`penalty-view-btn-${row.penalty_id}`}
                     onClick={() => onView(row)} title={t("penalty.actions.view")}>
            <Eye className="h-3.5 w-3.5" /> {t("penalty.actions.view")}
          </NeuButton>
        </div>
      </td>
    </tr>
  );
};
